export function generateHeading(title) {
  const header = document.createElement('header')
  header.classList.add('headlinestack', 'headlinestack__center')
  const h3Tag = document.createElement('h3')
  h3Tag.classList.add('headlinestack-main')

  h3Tag.innerText = title
  header.appendChild(h3Tag)

  return header
}